export const CSS_THEMES = {
  DEFAULT: "DEFAULT",
  WHITELABEL: "WHITELABEL",
  EVO: "EVO",
  GALAXYBET: "GALAXYBET",
};
